import React from 'react'
import DynamicComponent from '../Dynamic/DynamicComponent'

type RegionComponentTypes = {
  region: any
  className?: string
  subClassName?: string
  noWrapper?: boolean
  appMode: string
}

const RenderRegionComponents = ({
  region,
  subClassName = '',
  ...rest
}: RegionComponentTypes) => {
  return (
    <>
      {region.components &&
        region.components.map((component: any, index: number) => (
          <React.Fragment key={`region-component-${component.id}-${index}`}>
            <DynamicComponent
              component={component}
              className={subClassName}
              index={index}
              {...rest}
            />
          </React.Fragment>
        ))}
    </>
  )
}

const RegionComponent = ({
  region,
  className = '',
  subClassName = '',
  noWrapper = false,
  appMode,
  ...rest
}: RegionComponentTypes) => {
  if (!region) return <></>

  if (!noWrapper) {
    return (
      <div className={className}>
        <RenderRegionComponents
          region={region}
          subClassName={subClassName}
          {...rest}
        />
      </div>
    )
  }

  return (
    <RenderRegionComponents
      region={region}
      subClassName={subClassName}
      {...rest}
    />
  )
}

export default RegionComponent
